import Model from '@/models/Model'

export default class AccAccountingNote extends Model {
    resource() {
        return 'acc_accounting_seat/detailed'
    }

    static includes = [
        'g_generator_user.hr_employee',
        'conciliation',
        'acc_account',
        'acc_accounting_seat_status',
    ]

    get accountCode() {
        return this.acc_account ? this.acc_account.code : null
    }

    get accountComment() {
        return this.acc_account ? this.acc_account.comment : null
    }

    get generatorUserName() {
        return this.g_generator_user && this.g_generator_user.hr_employee
            ? this.g_generator_user.hr_employee.name_case
            : null
    }

    get accountingSeatStatus() {
        return this.acc_accounting_seat_status
            ? this.acc_accounting_seat_status.status
            : null
    }

    get conciliationTag() {
        return this.conciliation ? this.conciliation.tag : null
    }
}
